module.exports = __webpack_public_path__ + "img/spbu4.6b8adf23.png";